import { DefaultIntl } from "@effect-app/vue/commander"

export const sharedMessages = {
  de: {
    ...DefaultIntl.de,

    "action.Admin/Auth.Login": "Anmelden",
    "action.Admin/Me.UpdateMe": "Profil aktualisieren",
    "action.Admin/Me.SetConfiguratorFavorite": "Favorit speichern",
    "action.Admin/Users.UserInvite": "Benutzer einladen",

    "action.Admin/Shop.CreateShop": "Shop erstellen",
    "action.Admin/Shop.UpdateShop": "{_isLabel, select, true {Speichern} other {Shop aktualisieren}}",
    "action.Admin/Shop.RemoveShop": "Shop löschen",

    "action.Admin/RALColor.CreateRALColor": "RAL-Farbe erstellen",
    "action.Admin/RALColor.UpdateRALColor": "{_isLabel, select, true {Speichern} other {RAL-Farbe aktualisieren}}",
    "action.Admin/RALColor.RemoveRALColor": "RAL-Farbe löschen",

    "action.Admin/Configurator.CreateConfigurator": "Konfigurator erstellen",
    "action.Admin/Configurator.UpdateConfigurator":
      "{_isLabel, select, true {Speichern} other {Konfigurator aktualisieren}}",
    "action.Admin/Configurator.RemoveConfigurator": "Konfigurator löschen",
    "action.Admin/Configurator.CloneConfigurator": "Konfigurator klonen",
    "action.Admin/Configurator.SyncConfigurator":
      "{_isLabel, select, true {Mit Shops synchronisieren} other {Konfigurator synchronisieren}}",
    "action.Admin/Configurator.ImportConfigurator":
      "{_isLabel, select, true {Speichern} other {Konfigurator importieren}}",
    "action.Admin/Configurator.ExportConfigurator": "Konfigurator exportieren",

    "action.PriceUpdate.BuildBulkTable": "Bulk-Bearbeitung vorbereiten",
    "action.PriceUpdate.ImportCsv": "CSV importieren",

    "action.Admin/Configurator/Category.CreateConfiguratorCategory": "Kategorie erstellen",
    "action.Admin/Configurator/Category.UpdateConfiguratorCategory":
      "{_isLabel, select, true {Speichern} other {Kategorie aktualisieren}}",
    "action.Admin/Configurator/Category.RemoveConfiguratorCategory":
      "{_isLabel, select, true {Löschen} other {Kategorie löschen}}",

    "action.Admin/Configurator/Tag.CreateConfiguratorTag": "{_isLabel, select, true {Anlegen} other {Tag erstellen}}",
    "action.Admin/Configurator/Tag.UpdateConfiguratorTag":
      "{_isLabel, select, true {Speichern} other {Tag aktualisieren}}",
    "action.Admin/Configurator/Tag.RemoveConfiguratorTag": "{_isLabel, select, true {Löschen} other {Tag löschen}}",
    "action.Admin/Configurator/Tag.SetConfiguratorTags": "Tags speichern",

    "action.Admin/Configurator/ConditionGroup.CloneConfiguratorConditionGroup": "Bedingung klonen",
    "action.Admin/Configurator/ConditionGroup.ConditionGroupsToCopy": "Bedingungen abrufen",
    "action.Admin/Configurator/ConditionGroup.CopyConfiguratorConditionGroups": "Bedingungen kopieren",
    "action.Admin/Configurator/ConditionGroup.CreateConfiguratorConditionGroup": "Bedingung erstellen",
    "action.Admin/Configurator/ConditionGroup.UpdateConfiguratorConditionGroup":
      "{_isLabel, select, true {Speichern} other {Bedingung aktualisieren}}",
    "action.Admin/Configurator/ConditionGroup.RemoveConfiguratorConditionGroup": "Bedingung löschen",
    "action.Admin/Configurator/ConditionGroup.RestoreConfiguratorConditionGroup": "Bedingung wiederherstellen",
    "action.Admin/Configurator/ConditionGroup.SetConfiguratorConditionGroupNote": "Notiz speichern",
    "action.Admin/Configurator/ConditionGroup.SortConfiguratorConditionGroup": "Bedingungsgruppen sortieren",
    "action.Admin/Configurator/ConditionAi.ExplainConfiguratorConditionGroup": "Erklären",

    "action.Admin/Configurator/DXFConfig.CreateDXFConfig": "DXF-Konfiguration erstellen",
    "action.Admin/Configurator/DXFConfig.UpdateDXFConfig":
      "{_isLabel, select, true {Speichern} other {DXF-Konfiguration aktualisieren}}",
    "action.Admin/Configurator/DXFConfig.RemoveDXFConfig": "DXF-Konfiguration löschen",

    "action.Admin/Configurator/Option.AllConfiguratorOptions": "Optionen abrufen",
    "action.Admin/Configurator/Option.CloneConfiguratorOption": "Option klonen",
    "action.Admin/Configurator/Option.CreateConfiguratorOption":
      "{_isLabel, select, true {Speichern} other {Option erstellen}}",
    "action.Admin/Configurator/Option.RemoveConfiguratorOption": "Option löschen",
    "action.Admin/Configurator/Option.RestoreConfiguratorOption": "Option wiederherstellen",
    "action.Admin/Configurator/Option.SetConfiguratorOptionNote": "Notiz speichern",
    "action.Admin/Configurator/Option.SortConfiguratorOption": "Optionen sortieren",
    "action.Admin/Configurator/Option.UpdateConfiguratorOption":
      "{_isLabel, select, true {Speichern} other {Option aktualisieren}}",

    "action.Admin/Configurator/OptionGroup.CloneConfiguratorOptionGroup": "Optionen kopieren",
    "action.Admin/Configurator/OptionGroup.CreateConfiguratorOptionGroup": "Optionsgruppe erstellen",
    "action.Admin/Configurator/OptionGroup.UpdateConfiguratorOptionGroup":
      "{_isLabel, select, true {Speichern} other {Optionsgruppe aktualisieren}}",
    "action.Admin/Configurator/OptionGroup.RemoveConfiguratorOptionGroup": "Optionsgruppe löschen",
    "action.Admin/Configurator/OptionGroup.SortConfiguratorOptionGroup": "Optionsgruppen sortieren",

    "action.Admin/Configurator/PriceTable.CreateConfiguratorPriceTable": "Preistabelle erstellen",
    "action.Admin/Configurator/PriceTable.UpdateConfiguratorPriceTable":
      "{_isLabel, select, true {Speichern} other {Preistabelle aktualisieren}}",
    "action.Admin/Configurator/PriceTable.RemoveConfiguratorPriceTable": "Preistabelle löschen",
    "action.Admin/Configurator/PriceTable.SortConfiguratorPriceTable": "Preistabellen sortieren",

    "action.Admin/Configurator/ShowerPreviewer.CreateShowerPreviewer": "Duschvorschau erstellen",
    "action.Admin/Configurator/ShowerPreviewer.UpdateShowerPreviewer":
      "{_isLabel, select, true {Speichern} other {Duschvorschau aktualisieren}}",
    "action.Admin/Configurator/ShowerPreviewer.RemoveShowerPreviewer":
      "{_isLabel, select, true {Shower Previewer löschen} other {Duschvorschau löschen}}",

    "action.Preconfiguration.CreatePreconfiguration": "Vorkonfiguration erstellen",
    "action.Preconfiguration.UpdatePreconfiguration":
      "{_isLabel, select, true {Speichern} other {Vorkonfiguration aktualisieren}}",
    "action.Preconfiguration.DeletePreconfiguration":
      "{_isLabel, select, true {Löschen} other {Vorkonfiguration löschen}}",
    "action.Configuration.CreateConfiguration": "Konfiguration erstellen",
    "action.Configuration.AddToCartConfiguration": "Zum Warenkorb hinzufügen",
    "action.Configuration.UpdateCartConfiguration": "Warenkorb aktualisieren",
    "action.Configuration.UpdateConfiguration": "Konfiguration aktualisieren",
    "action.Configuration.UploadShowerPreviewImage": "Duschvorschau-Bild hochladen",
    "action.Project/Configuration.AddProjectConfiguration": "Projekt hinzufügen",
    "action.Project/Configuration.CopyProjectConfiguration": "Projekt kopieren",
    "action.Project/Configuration.UpdateProjectConfiguration": "Projektkonfiguration aktualisieren",
    "action.Project/Configuration.RemoveProjectConfiguration": "Projektkonfiguration entfernen",
    "action.Project/Configuration.RemoveMultipleProjectConfiguration": "Projektkonfigurationen entfernen",
    "action.Project.AddProjectToCart": "Hinzufügen",
    "action.Project.CreateProject": "Projekt erstellen",
    "action.Project.RemoveProject": "Projektliste löschen",
    "action.Project.UpdateProject": "{_isLabel, select, true {Speichern} other {Projekt aktualisieren}}",
    "action.Project.UpdateProjectOffer": "Angebot erfolgreich aktualisiert",
    "action.Magento.RemoveCartItem": "Artikel entfernen",
    "action.Company.UpdateCompany": "{_isLabel, select, true {Speichern} other {Firma aktualisieren}}",
    "action.Test.SeedNamespace": "Test-Datenbereich initialisieren",

    "action.MinDXF.RunMinDXF": "Nesting berechnen",
    "action.MinDXF.ListAbasInputFiles": "ABAS-Dateien abrufen",
    "action.MinDXF.FetchAbasInputFile": "ABAS-Datei laden",
    "action.MinDXF.ExportMinDXFToAbas": "Zu ABAS exportieren",

    "form.includes_error": "Bitte überprüfen Sie Ihre Angaben",
    "form.fix_input": "Beheben",

    "validation.empty": `Das Feld darf nicht leer sein`,
    "validation.email.invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "validation.number.max":
      "Der Wert sollte {isExclusive, select, true {kleiner als} other {höchstens}} {maximum} sein",
    "validation.number.min":
      `Der Wert sollte {isExclusive, select, true {größer als} other {mindestens}} {minimum} sein`,
    "validation.number.positive": `Der Wert muss größer als 0 sein`,
    "validation.integer.expected": "Es wird eine ganze Zahl erwartet, tatsächlich: {actualValue}",
    "validation.number.expected": "Es wird eine Zahl erwartet, tatsächlich: {actualValue}",
    "validation.string.maxLength": `Das Feld darf nicht mehr als {maxLength} Zeichen haben`,
    "validation.string.minLength": `Das Feld muss mindestens {minLength} Zeichen enthalten`,
    "validation.not_a_valid": `Der eingegebene Wert ist kein gültiger {type}: {message}`,
    "validation.failed": "Ungültige Eingabe"
  },
  en: {
    ...DefaultIntl.en,

    "form.includes_error": "Please check your input",
    "form.fix_input": "Fix it",

    "validation.empty": "The field cannot be empty",
    "validation.email.invalid": "Please enter a valid email address",
    "validation.number.max": "The value should be {isExclusive, select, true {smaller than} other {at most}} {maximum}",
    "validation.number.min": "The value should be {isExclusive, select, true {larger than} other {at least}} {minimum}",
    "validation.number.positive": "The value should be positive",
    "validation.integer.expected": "Expected an integer, actual: {actualValue}",
    "validation.number.expected": "Expected a number, actual: {actualValue}",
    "validation.string.maxLength": "The field cannot have more than {maxLength} characters",
    "validation.string.minLength": "The field requires at least {minLength} characters",
    "validation.not_a_valid": "The entered value is not a valid {type}: {message}",
    "validation.failed": "Invalid input"
  }
}
